/* eslint-disable no-console */
import privateNetwork from '@adm/services/networkRequest';
/**
 * Importação da biblioteca axios para fazer requisições baseadas em Promises.
 */
import axios from 'axios';

const apiVersion = '/v1';
const endPoint = '/modulo';

/**
 * Classe que representa os módulos
 */
export default class Modules {
  /**
   * Método de requisição dos módulos
   */
  static async get() {
    try {
      const response = await axios(
        `${process.env.REACT_APP_API_HOST}${apiVersion}${endPoint}`
      );
      const modules = [];
      response.data._embedded.modulo.forEach((elem) => {
        const data = JSON.parse(elem.dado);
        if (data && data.titulo) {
          modules.push({
            id: elem.id,
            ...data,
          });
        }
      });
      return modules;
    } catch (err) {
      console.error('Erro de requisição modulo:', err);
      return [];
    }
  }

  /**
   * Com argumento values opcional, caso exista prop,
   * verifica se o item está repetido. Caso positivo
   * retorna true, caso negativo falso. Caso o
   * argumento não seja passado uma lista com todas
   * as propriedades são retornadas
   *
   * @param {string} prop propriedade a ser pesquisada
   * @param {string} value valor a ser buscado
   */
  static async returnProps(prop, value) {
    const modules = await Modules.get();
    if (value) {
      let valueExists = false;
      modules.forEach((elem) => {
        if (elem[prop] === value) valueExists = true;
      });
      return !valueExists;
    }
    const values = [];
    modules.forEach((elem) => {
      values.push(elem[prop]);
    });
    return values;
  }

  static async aliases(alias) {    
    return Modules.returnProps('apelido', alias);
  }

  static async names(name) {
    return Modules.returnProps('titulo', name);
  }

  /**
   * Retorna um módulo através do seu id
   *
   * @param {Number} id
   */
  static async getOne(id) {
    return axios(
      `${process.env.REACT_APP_API_HOST}${apiVersion}${endPoint}/${id}`
    );
  }

  /**
   * Retorna um módulo através de sua url
   *
   * @param {String} url
   */
  static async getByURL(url) {
    try {
      const response = await axios(
        `${process.env.REACT_APP_API_HOST}${apiVersion}${endPoint}`
      );
      let module = null;
      response.data._embedded.modulo.forEach((elem) => {
        const data = JSON.parse(elem.dado);
        if (data.endereco === url) {
          module = {
            id: elem.id,
            ...data,
          };
        }
      });
      return module;
    } catch (err) {
      console.error('Erro de requisição modulo:', err);
      return null;
    }
  }

  /**
   * Envia dados de um módulo
   *
   * @param {*} body
   */
  static async post(body) {
    return privateNetwork.post(`${apiVersion}${endPoint}`, body);
  }

  /**
   * Altera dados de um módulo
   *
   * @param {*} body
   */
  static async put(body) {
    return privateNetwork.put(`${apiVersion}${endPoint}/${body.id}`, body);
  }

  /**
   * Deleta um módulo
   *
   * @param {Number} id
   */
  static async delete(id) {
    return privateNetwork.delete(`${apiVersion}${endPoint}/${id}`);
  }
}
